/* ============================================
 * Keyboard navigation for mega menu tab panels
 * ============================================ */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab') return;

  const activeTab = document.querySelector('.mega-menu-tabbed__tab--is-active');
  if (!activeTab || activeTab.dataset.hasLinks !== 'true') return;

  const container = activeTab.closest('.snippet-tabbed');
  const panel = container?.querySelector(`.mega-menu-tabbed__panel[data-panel="${activeTab.dataset.panel}"]`);
  if (!panel || panel.hidden) return;

  const focusable = Array.from(panel.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'));
  if (!focusable.length) return;

  const current = document.activeElement;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const tabs = Array.from(container.querySelectorAll('.mega-menu-tabbed__tab'));
  const nextTab = tabs[tabs.indexOf(activeTab) + 1];

  if (!e.shiftKey && current === activeTab) {
    e.preventDefault();
    first.focus();
  } else if (!e.shiftKey && current === last && nextTab) {
    e.preventDefault();
    nextTab.focus();
    nextTab.dispatchEvent(new FocusEvent('focus'));
  } else if (e.shiftKey && current === first) {
    e.preventDefault();
    activeTab.focus();
  }
});

/* ============================================
 * Quickshop Popup
 * ============================================ */
let quickShopButton = null;

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-quick-shop-cta');

  if (btn) {
    quickShopButton = btn;

    setTimeout(() => {
      const popup = document.querySelector(btn.getAttribute('data-trigger'));
      const closeBtn = popup?.querySelector('.js-qs-close');

      if (closeBtn) closeBtn.focus();
    }, 150);
  }

  if (e.target.closest('.js-qs-close') && quickShopButton) {
    setTimeout(() => {
      if (quickShopButton?.isConnected) quickShopButton.focus();
      quickShopButton = null;
    }, 100);
  }
});

document.addEventListener('keydown', (e) => {
  const popup = document.querySelector('.product-quick-shop[style*="block"]');
  if (!popup) return;

  if (e.key === 'Escape') {
    popup.querySelector('.js-qs-close')?.click();
    return;
  }

  if (e.key === 'Tab') {
    const focusable = Array.from(
      popup.querySelectorAll('button, a, input, select, [tabindex]:not([tabindex="-1"])')
    ).filter(el => el.offsetParent !== null);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const current = document.activeElement;

    e.preventDefault();

    if (!e.shiftKey && current === last) {
      first.focus();
    } else if (e.shiftKey && current === first) {
      last.focus();
    } else {
      focusable[focusable.indexOf(current) + (e.shiftKey ? -1 : 1)]?.focus();
    }
  }
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-quick-shop-cta');
  if (!btn) return;
  
  setTimeout(() => {
    const popup = document.querySelector(btn.getAttribute('data-trigger'));
    if (popup) {
      popup.querySelectorAll('[tabindex="-1"]').forEach(el => el.setAttribute('tabindex', '0'));
      popup.querySelector('.js-qs-close')?.focus();
    }
  }, 150);
});

document.addEventListener('keydown', (e) => {
  const current = e.target.closest('.quick-shop__input label');
  if (!current) return;

  const group = current.closest('.quick-shop__input');
  if (!group) return;

  const items = [...group.querySelectorAll('label')];
  const index = items.indexOf(current);

  // ENTER / SPACE = select
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    current.click();
    return;
  }

  // ARROW NAVIGATION
  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
    e.preventDefault();
    (items[index + 1] || items[0]).focus();
  }

  if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
    e.preventDefault();
    (items[index - 1] || items[items.length - 1]).focus();
  }
});

// Quickshop selected option
$(document).on('click change', '.quick-shop__input input[type="radio"]', function() {
  var $radio = $(this);
  if ($radio.prop('checked')) {
    setTimeout(function() {
      var $container = $radio.closest('.quick-shop__input');
      var optionName = $container.find('.form__label').text().trim();
      var optionValue = $radio.val();
      
      var $announcer = $('#swatch-announcer');
      if (!$announcer.length) {
        $announcer = $('<div id="swatch-announcer" aria-live="polite" class="visually-hidden"></div>');
        $('body').append($announcer);
      }
      $announcer.text(optionName + ' ' + optionValue + ' selected');
    }, 50);
  }
});

$(document).on('keydown', '.quick-shop__input label', function(e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    e.preventDefault();
    $(this).trigger('click');
  }
});

/* ============================================
 * Featured Categories Slider
 * ============================================ */
let allItems = [];

function updateAllItems(slider) {
  allItems = [];
  slider.querySelectorAll('.slick-slide:not(.slick-cloned)').forEach(slide => {
    slide.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])').forEach(item => {
      allItems.push(item);
    });
  });
}

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab') return;
  
  const activePanel = document.querySelector('.featured-category-tabs__panel.is-active');
  if (!activePanel) return;
  
  const slider = activePanel.querySelector('.featured-category-tabs__slider.slick-initialized');
  if (!slider) return;
  
  updateAllItems(slider);
  if (allItems.length === 0) return;
  
  const current = document.activeElement;
  const currentIndex = allItems.indexOf(current);
  if (currentIndex === -1 || currentIndex === allItems.length - 1) return;
  
  const nextItem = allItems[currentIndex + 1];
  if (nextItem) {
    const nextSlide = $(nextItem).closest('.slick-slide');
    const slideIndex = nextSlide.data('slick-index');
    const $slider = $(slider);
    const slick = $slider.slick('getSlick');
    
    if (slick && slideIndex !== undefined && slideIndex !== slick.currentSlide) {
      e.preventDefault();
      $slider.slick('slickGoTo', slideIndex);
      setTimeout(() => nextItem.focus(), 200);
    }
  }
});

document.querySelectorAll('.card-information__variant-image').forEach(el => {
  el.setAttribute('tabindex', '0');
  el.addEventListener('click', e => {
    const img = el.querySelector('img');
    const main = el.closest('.card-wrapper--featured-tabs')?.querySelector('.card-mainimg');
    if (main && img?.dataset.featured) main.src = img.dataset.featured;
  });
  el.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      el.click();
    }
  });
});

/* ============================================
 * Image Bar Slider
 * ============================================ */
$('.has-ada-slider').each(function() {
  var $slider = $(this);
  var allItems = [];
  
  function updateItems() {
    allItems = [];
    $slider.find('.slick-slide:not(.slick-cloned) a[href], .slick-slide:not(.slick-cloned) button').each(function() {
      allItems.push(this);
    });
  }
  
  $(document).on('keydown', function(e) {
    if (e.key !== 'Tab') return;
    updateItems();
    var idx = allItems.indexOf(document.activeElement);
    if (idx === -1 || idx === allItems.length - 1) return;
    
    var $next = $(allItems[idx + 1]);
    var $slide = $next.closest('.slick-slide');
    var slideIdx = $slide.data('slick-index');
    var slick = $slider.slick('getSlick');
    
    if (slick && slideIdx !== undefined && slideIdx !== slick.currentSlide) {
      e.preventDefault();
      $slider.slick('slickGoTo', slideIdx);
      setTimeout(function() { $next.focus(); }, 150);
    }
  });
});

/* ============================================
 * Add tabindex to GFA App
 ============================================ */
let lastFocusedElement = null;

function initPopupSystem() {
  const triggers = document.querySelectorAll(
    '.gfa-content__text, .gfa-media video, .gfa-media img'
  );

  triggers.forEach(el => {
    el.setAttribute('tabindex', '0');

    // Decorative popup-trigger video: use title (not aria-label) for the
    // accessible name. aria-label is invalid on <video> (its role prohibits
    // naming); title supplies a name without tripping that rule.
    if (el.tagName.toLowerCase() === 'video') {
      el.removeAttribute('aria-label');
      if (!el.getAttribute('title')) el.setAttribute('title', 'Play video');
    }

    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();

        lastFocusedElement = el;
        el.click();

        waitForPopup();
      }
    });
  });

  // button container aria-label from text
  document
    .querySelectorAll('.gfa-content__button-container a')
    .forEach(a => {
      const text = a.textContent?.trim();
      if (text) {
        a.setAttribute('aria-label', text);
      }
    });
}

function waitForPopup() {
  const timer = setInterval(() => {
    const popup = document.querySelector('.gfa-popup');

    if (popup) {
      clearInterval(timer);
      activateModal(popup);
    }
  }, 50);
}

function activateModal(popup) {

  const closeBtn = popup.querySelector('.gfa-popup__close-button');
  const rightArrow = popup.querySelector('.gfa-popup-arrow-right');
  const leftArrow = popup.querySelector('.gfa-popup-arrow-left');

  if (closeBtn) closeBtn.setAttribute('aria-label', 'close');
  if (rightArrow) rightArrow.setAttribute('aria-label', 'next');
  if (leftArrow) leftArrow.setAttribute('aria-label', 'previous');

  const focusItems = [
    closeBtn,
    popup.querySelector('.gfa-popup-media'),
    leftArrow,
    rightArrow,
    popup.querySelector('.gfa-copyright--popup')
  ].filter(Boolean);

  focusItems.forEach(el => el.setAttribute('tabindex', '0'));

  let index = 0;
  focusItems[index]?.focus();

  function keyHandler(e) {
    const active = document.activeElement;

    if (!popup) return;

    if (e.key === 'Tab') {
      if (!popup.contains(active)) return;

      e.preventDefault();

      index = e.shiftKey
        ? (index - 1 + focusItems.length) % focusItems.length
        : (index + 1) % focusItems.length;

      focusItems[index]?.focus();
      return;
    }

    if (e.key === 'Enter') {
      if (popup.contains(active)) {
        e.preventDefault();
        active?.click();
      }
      return;
    }

    if (e.key === 'Escape') {
      closeBtn?.click();
    }
  }

  document.addEventListener('keydown', keyHandler);

  const check = setInterval(() => {
    if (!document.querySelector('.gfa-popup')) {
      clearInterval(check);
      document.removeEventListener('keydown', keyHandler);

      setTimeout(() => {
        lastFocusedElement?.focus();
      }, 0);
    }
  }, 50);
}

initPopupSystem();

document.querySelectorAll('.gfa-media a')
    .forEach(el => el.setAttribute('tabindex', '-1'));


/* ============================================
 * Header: Add tabindex to country popup
 ============================================ */
(function () {
  const popup = document.querySelector('.md-app-embed');
  if (!popup) return;

  let handled = false;
  const interval = setInterval(() => {
  const isOpen = !popup.classList.contains('orbe--hidden');

    if (isOpen && !handled) {
      handled = true;

      setTimeout(() => {
        const items = popup.querySelectorAll('li[tabindex]');

        items.forEach(li => {
          li.setAttribute('tabindex', '0');
        });
      }, 300);

      clearInterval(interval);
    }
  }, 200);
})();


/* ============================================
 * Collection Page: Description
 ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.collection-hero__description a');

  links.forEach(a => {
    const text = a.textContent.trim();
    if (text) {
      a.setAttribute('aria-label', text);
    }
  });
});


/* ============================================
 * Collection Page: Filter Dropdown Trigger
 ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  // The filter header title acts as the disclosure button (role="button").
  document.addEventListener('keydown', function (e) {
    const active = document.activeElement;

    if (
      active &&
      (active.classList.contains('js-filter-label') || active.classList.contains('filter-chev')) &&
      (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32)
    ) {
      e.preventDefault();
      active.click();
    }
  });

  // Keep aria-expanded in sync when a filter header is toggled.
  document.addEventListener('click', function (e) {
    const summary = e.target.closest('.facets__summary');
    if (!summary) return;
    const btn = summary.querySelector('.js-filter-label[role="button"]');
    if (!btn) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });
});


/* ============================================
 * Collection Page: Swatches
 ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-wrapper .swatch-element').forEach(el => {

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        this.click();
      }
    });
  });
});


/* ============================================
 * Disable cross sell focus
 ============================================ */
function disableCrossSellFocus() {
  const modal = document.getElementById('cross-sells');
  if (!modal) return;

  if (!modal.classList.contains('open')) {
    modal.setAttribute('inert', '');

    modal.querySelectorAll('a, button, select, input, textarea').forEach(el => {
      el.setAttribute('tabindex', '-1');
    });
  } else {
    modal.removeAttribute('inert');

    modal.querySelectorAll('a, button, select, input, textarea').forEach(el => {
      el.removeAttribute('tabindex');
    });
  }
}

setInterval(disableCrossSellFocus, 300);


// Focus on continue shopping when drawer opens
function setupDrawerFocusTrap() {
  const drawer = document.getElementById('cross-sells');
  if (!drawer) return;
  
  let isDrawerOpen = false;
  let focusableElements = [];
  
  function getFocusableElements() {
    return Array.from(drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex="0"], [tabindex]:not([tabindex="-1"])'))
      .filter(el => {
        return !el.disabled && el.offsetParent !== null;
      });
  }
  
  function updateFocusableElements() {
    focusableElements = getFocusableElements();
  }
  
  function setInitialFocus() {
    updateFocusableElements();
    
    let continueButton = drawer.querySelector('.cross-sells-continue-shopping');
    
    if (!continueButton) {
      for (let i = 0; i < focusableElements.length; i++) {
        const el = focusableElements[i];
        if (el.textContent && el.textContent.trim().toLowerCase().includes('continue shopping')) {
          continueButton = el;
          break;
        }
      }
    }
    
    if (continueButton && continueButton.offsetParent !== null) {
      continueButton.focus();
    } else if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }
  
  function trapFocus(e) {
    if (!isDrawerOpen) return;
    
    if (e.key === 'Enter') {
      const activeElement = document.activeElement;
      if (activeElement && activeElement.click) {
        e.preventDefault();
        activeElement.click();
        return;
      }
    }
    
    updateFocusableElements();
    
    if (focusableElements.length === 0) return;
    
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
    
    if (e.key === 'Escape') {
      drawer.style.display = 'none';
      drawer.classList.remove('open');
      isDrawerOpen = false;
      document.removeEventListener('keydown', trapFocus);
      document.removeEventListener('focusin', handleFocusIn);
    }
  }
  
  function handleFocusIn(e) {
    if (isDrawerOpen && !drawer.contains(e.target)) {
      updateFocusableElements();
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        const isOpen = drawer.classList.contains('open');
        
        if (isOpen && !isDrawerOpen) {
          isDrawerOpen = true;
          drawer.style.display = 'block';
          setTimeout(function() {
            setInitialFocus();
            document.addEventListener('keydown', trapFocus);
            document.addEventListener('focusin', handleFocusIn);
          }, 150);
        } else if (!isOpen && isDrawerOpen) {
          isDrawerOpen = false;
          drawer.style.display = 'none';
          document.removeEventListener('keydown', trapFocus);
          document.removeEventListener('focusin', handleFocusIn);
        }
      }
    });
  });
  
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  
  const childObserver = new MutationObserver(function() {
    if (isDrawerOpen) {
      updateFocusableElements();
    }
  });
  
  childObserver.observe(drawer, { 
    childList: true, 
    subtree: true 
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupDrawerFocusTrap);
} else {
  setupDrawerFocusTrap();
}


/* ============================================
 * PDP: Product Images
 ============================================ */
document.addEventListener('keydown', function(e) {
  const target = e.target;
  if (target.classList.contains('product-single__thumbnails-item') && 
      (e.key === 'Enter' || e.keyCode === 13)) {
    e.preventDefault();
    target.click();
  }
});

function managePopupFocus() {
  const popup = document.querySelector('.gallery_popup.open-pop');
  if (!popup) return;

  const closeButton = popup.querySelector('.pop_close');
  const focusable = Array.from(
    popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter(el => el.offsetParent !== null);

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  // Focus close button when popup opens
  setTimeout(() => closeButton?.focus(), 50);

  function trapFocus(e) {
    if (e.key !== 'Tab') return;

    if (!popup.contains(document.activeElement)) {
      e.preventDefault();
      closeButton?.focus();
      return;
    }

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last?.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first?.focus();
    }
  }

  document.addEventListener('keydown', trapFocus);
  return () => document.removeEventListener('keydown', trapFocus);
}

// Handle Enter key on close button to trigger click
document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    const target = e.target;
    if (target?.classList?.contains('pop_close')) {
      e.preventDefault();
      target.click();
    }
  }
});

function setupPopupObserver() {
  const popup = document.querySelector('.gallery_popup');
  if (!popup) return;

  let cleanup = null;

  const observer = new MutationObserver(() => {
    if (popup.classList.contains('open-pop')) {
      cleanup?.();
      cleanup = managePopupFocus();
    } else {
      cleanup?.();
      cleanup = null;
      window._lastFocusedElement?.focus();
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('focusin', (e) => {
    if (!popup.classList.contains('open-pop')) {
      window._lastFocusedElement = e.target;
    }
  });

  return observer;
}

document.addEventListener('DOMContentLoaded', setupPopupObserver);


/* ============================================
 * PDP: Star rating reverse tabindex
 ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('.product-template__container .oke-is-clickable').forEach(el => {
      el.setAttribute('tabindex', '-1');
    });
  }, 2000);
});

document.querySelectorAll('.fixed_images .lems-gif-pause').forEach(el => {
  el.setAttribute('tabindex', '-1');
});


/* ============================================
 * PDP: Size chart
 ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const el = document.querySelector('.ks-chart-modal-link');

    if (!el) return;

    el.setAttribute('tabindex', '0');

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        el.click();
      }
    });
  }, 3000);
});

(() => {
  let trapActive = false;

  function restoreFocusToChartLink() {
    const chartLink = document.querySelector('.ks-chart-modal-link');

    if (chartLink) {
      chartLink.setAttribute('tabindex', '0');

      setTimeout(() => {
        chartLink.focus();
      }, 50);
    }
  }

  function getFocusable(wrapper) {
    const outsideClose = document.querySelector('.ks-modal-close');

    const inside = [
      ...wrapper.querySelectorAll(`
        .modal-title-header,
        .modal-title-sub-header,
        .ks-table-header,
        .ks-unit-toggle-label,
        .ks-table td,
        button,
        [href],
        input,
        select,
        textarea,
        [tabindex]:not([tabindex="-1"])
      `)
    ].filter(
      el => el.offsetParent !== null && !el.hasAttribute('disabled')
    );

    if (outsideClose && wrapper.textContent.trim().length > 0) {
      return [outsideClose, ...inside];
    }

    return inside;
  }

  function activateTrap(wrapper) {
    if (trapActive) return;

    trapActive = true;

    wrapper.querySelectorAll(`
      .ks-modal-logo,
      .modal-title-header,
      .modal-title-sub-header,
      .ks-table-header,
      .ks-unit-toggle-label,
      .ks-table td,
      .ks-html-content p,
      .ks-html-content ul,
      .ks-html-content ol,
      .ks-ac-item-label,
      .ks-image
    `).forEach(el => {
      el.setAttribute('tabindex', '0');
    });

    wrapper.querySelectorAll('.ks-ac-item input').forEach(input => {
      input.setAttribute('tabindex', '-1');
    });

    const closeBtn = document.querySelector('.ks-modal-close');

    if (closeBtn) {
      closeBtn.setAttribute('tabindex', '0');

      if (!closeBtn.dataset.focusBound) {
        closeBtn.dataset.focusBound = 'true';

        closeBtn.addEventListener('click', () => {
          setTimeout(() => {
            restoreFocusToChartLink();
            trapActive = false;
          }, 100);
        });
      }
    }

    function focusFirst() {
      const focusables = getFocusable(wrapper);

      if (focusables.length) {
        focusables[0].focus();
      }
    }

    function handleTab(e) {
      if (e.key !== 'Tab') return;

      const focusables = getFocusable(wrapper);

      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function handleEnter(e) {
      if (e.key !== 'Enter') return;

      const el = document.activeElement;

      if (
        el.classList.contains('ks-unit-toggle-label') ||
        el.classList.contains('ks-ac-item-label') ||
        el.classList.contains('ks-modal-close')
      ) {
        e.preventDefault();

        if (el.classList.contains('ks-modal-close')) {
          el.click();

          setTimeout(() => {
            restoreFocusToChartLink();
            trapActive = false;
          }, 100);
        } else {
          el.click();
        }
      }
    }

    setTimeout(focusFirst, 50);

    document.addEventListener('keydown', handleTab);
    document.addEventListener('keydown', handleEnter);
  }

  function setOutsideCloseTabindex(wrapper) {
    if (!wrapper) return;

    if (!wrapper.textContent || !wrapper.textContent.trim().length) {
      return;
    }

    const closeBtn = document.querySelector('.ks-modal-close');

    if (closeBtn && !wrapper.contains(closeBtn)) {
      closeBtn.setAttribute('tabindex', '0');
    }
  }

  function init() {
    const bodyObserver = new MutationObserver(() => {
      const wrapper = document.querySelector('.ks-modal-content-wrapper');

      if (!wrapper) return;

      const contentObserver = new MutationObserver(() => {
        if (
          wrapper.textContent &&
          wrapper.textContent.trim().length > 0
        ) {
          activateTrap(wrapper);
          setOutsideCloseTabindex(wrapper);
          contentObserver.disconnect();
        }
      });

      contentObserver.observe(wrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });

      bodyObserver.disconnect();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  init();
})();


/* ============================================
 * PDP: Restock links
 ============================================ */
(() => {
  document.querySelectorAll('.restock-page-info-bar a').forEach(link => {
    const text = (link.textContent || '').trim();

    if (text && !link.hasAttribute('aria-label')) {
      link.setAttribute('aria-label', text);
    }

    if (!link.hasAttribute('tabindex')) {
      link.setAttribute('tabindex', '0');
    }
  });
})();


/* ============================================
 * PDP: Locally change location
 ============================================ */
setTimeout(() => {
  document.querySelectorAll(
    '.lcly-location-prompt-link, .lcly-location-prompt-label'
  ).forEach(el => {
    el.setAttribute('tabindex', '0');

    if (!el.dataset.enterBound) {
      el.dataset.enterBound = '1';

      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          el.click();
          setTimeout(() => {
            document.activeElement?.blur();
          }, 10);
        }
      });
    }
  });

  var linkContentChange = document.getElementById('lcly-location-prompt-link-0');
  var linkContent = document.getElementById('lcly-link-0');

  if (linkContentChange) {
    var textContent = linkContentChange.textContent || linkContentChange.innerText;
    linkContentChange.setAttribute('aria-label', textContent);
  }

  if (linkContent) {
    var textContent = linkContent.textContent || linkContent.innerText;
    linkContent.setAttribute('aria-label', textContent);
  }
}, 3000);

(function () {
  const initFocusObserver = () => {
    const host = document.querySelector('#lcly_shadow_root');

    if (!host || !host.shadowRoot) {
      setTimeout(initFocusObserver, 200);
      return;
    }

    const addTabIndex = () => {
      const selectors = [
        '.product__image__wrapper',
        '.product__details__brand',
        '.product__details__name',
        '.product__details__price',
        '.product__mods__colors label',
        '.input__wrapper',
        '.store__view__filters',
        '.modal__header',
        '.product__header__info h2',
        '.product__header__info p',
        '.input__wrapper span'
      ];

      selectors.forEach(selector => {
        const elements = host.shadowRoot.querySelectorAll(selector);
        elements.forEach(el => {
          if (!el.hasAttribute('tabindex')) {
            el.setAttribute('tabindex', '0');
          }
        });
      });
    };

    const getFocusableElements = () => {
      const dialog = host.shadowRoot.querySelector('[role="dialog"]');
      if (!dialog) return [];
      
      return Array.from(dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.disabled && el.offsetParent !== null);
    };

    const handleFocusTrap = (event) => {
      const dialog = host.shadowRoot.querySelector('[role="dialog"]');
      if (!dialog) return;

      const focusableElements = getFocusableElements();
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = host.shadowRoot.activeElement;

      if (!dialog.contains(activeElement)) {
        event.preventDefault();
        const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');
        if (closeBtn) {
          closeBtn.focus();
        } else {
          firstElement.focus();
        }
        return;
      }

      if (event.key === 'Tab') {
        if (event.shiftKey && activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } 
        else if (!event.shiftKey && activeElement === lastElement) {
          event.preventDefault();
          const filtersElement = host.shadowRoot.querySelector('.store__view__filters');
          if (filtersElement && filtersElement.contains(activeElement)) {
            const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');
            if (closeBtn) {
              event.preventDefault();
              closeBtn.focus();
              return;
            }
          }
          firstElement.focus();
        }
      }
    };

    const setupFiltersFocusTrap = () => {
      const filtersElement = host.shadowRoot.querySelector('.store__view__filters');
      if (!filtersElement) return;

      const filtersFocusable = filtersElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (filtersFocusable.length === 0) {
        filtersElement.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && !event.shiftKey) {
            const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');
            if (closeBtn) {
              event.preventDefault();
              closeBtn.focus();
            }
          }
        });
      } else {
        const lastFilterElement = filtersFocusable[filtersFocusable.length - 1];
        lastFilterElement.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && !event.shiftKey) {
            const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');
            if (closeBtn) {
              event.preventDefault();
              closeBtn.focus();
            }
          }
        });
      }
    };

    const injectRedFocusStyles = () => {
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        *:focus {
          outline: .2rem solid #ff0000 !important;
        }
      `;
      host.shadowRoot.appendChild(styleElement);
    };

    const observer = new MutationObserver(() => {
      const dialog = host.shadowRoot.querySelector('[role="dialog"]');
      const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');

      if (dialog && closeBtn && host.shadowRoot.activeElement !== closeBtn) {
        requestAnimationFrame(() => {
          closeBtn.focus();
          setupFiltersFocusTrap();
          host.shadowRoot.removeEventListener('focusin', handleFocusTrap);
          host.shadowRoot.addEventListener('focusin', handleFocusTrap);
          dialog.removeEventListener('keydown', handleFocusTrap);
          dialog.addEventListener('keydown', handleFocusTrap);
        });
      }

      addTabIndex();
    });

    observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true
    });

    injectRedFocusStyles();
    addTabIndex();
    
    const dialog = host.shadowRoot.querySelector('[role="dialog"]');
    if (dialog) {
      const closeBtn = host.shadowRoot.querySelector('button[aria-label="close"]');
      if (closeBtn) {
        setTimeout(() => {
          closeBtn.focus();
          setupFiltersFocusTrap();
          host.shadowRoot.addEventListener('focusin', handleFocusTrap);
          dialog.addEventListener('keydown', handleFocusTrap);
        }, 100);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFocusObserver);
  } else {
    initFocusObserver();
  }
})();


/* ============================================
 * PDP: Also Available As
 * The "also available" cards are now single focusable links (see also-in.liquid);
 * no tabindex overrides needed here.
 ============================================ */


/* ============================================
 * PDP: Accordions
 ============================================ */
 setTimeout(() => {
  document.querySelectorAll('.single-tab-content a').forEach(el => {
    const text = (el.textContent || '').trim();

    if (text) {
      el.setAttribute('aria-label', text);
    }
  });
}, 3000);

/* ============================================
 * PDP: Lifestyle Section
 ============================================ */
(function() {
  let lastFocusedElement = null;
  
  function storeFocus() {
    lastFocusedElement = document.activeElement;
  }
  
  function restoreFocus() {
    if (lastFocusedElement && lastFocusedElement.focus) {
      setTimeout(() => {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }, 200);
    }
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    
    var el = document.activeElement;
    if (!el || !el.closest('.lifestyle-gallery')) return;
    
    e.preventDefault();
    storeFocus();
    
    var slide = el.closest('.slick-slide');
    if (!slide) return;
    
    var img = slide.querySelector('img');
    img ? img.click() : slide.click();
  });
  
  var popup = document.querySelector('.image-popup-mobile');
  if (!popup) return;
  
  var closeBtn = popup.querySelector('.close-popup-mobile');
  var images = popup.querySelectorAll('img');
  
  images.forEach(img => {
    img.setAttribute('tabindex', '0');
  });
  
  document.addEventListener('keydown', function(e) {
    var isPopupOpen = popup && getComputedStyle(popup).display === 'block';
    if (!isPopupOpen) return;
    
    var active = document.activeElement;
    
    if (e.key === 'Enter' && active === closeBtn) {
      e.preventDefault();
      closeBtn.click();
      restoreFocus();
      return;
    }
    
    if (e.key === 'Escape') {
      e.preventDefault();
      closeBtn.click();
      restoreFocus();
      return;
    }
    
    if (e.key === 'Tab') {
      if (e.shiftKey && active === closeBtn) {
        e.preventDefault();
        if (images.length) images[images.length - 1].focus();
      } else if (!e.shiftKey && active === images[images.length - 1]) {
        e.preventDefault();
        closeBtn.focus();
      }
    }
  });
  
  if (closeBtn) {
    closeBtn.addEventListener('click', () => restoreFocus());
  }
  
  setInterval(() => {
    if (popup && getComputedStyle(popup).display === 'block' && !popup.contains(document.activeElement)) {
      closeBtn.focus();
    }
  }, 100);
})();


/* ============================================
 * PDP: Video play button
 ============================================ */
document.querySelectorAll('.play-button svg').forEach(svg => {
  svg.setAttribute('tabindex', '0');

  if (!svg.dataset.enterBound) {
    svg.dataset.enterBound = '1';

    svg.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        svg.closest('.play-button')?.click();
      }
    });
  }
});


/* ============================================
 * PDP: Sticky bar
 ============================================ */
document.querySelectorAll('.sticky-size .form__label').forEach(el => {
  el.setAttribute('tabindex', '0');

  el.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      el.click();
    }
  });
});

/* ============================================
 * PDP: Swatches trigger
 ============================================ */
document.addEventListener('keydown', function (e) {
  const current = e.target.closest('.product-single__meta .swatch-element label');
  if (!current) return;

  const swatch = current.closest('.swatch');
  if (!swatch) return;

  const options = [...swatch.querySelectorAll('.swatch-element label')];
  const index = options.indexOf(current);

  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
    e.preventDefault();
    (options[index + 1] || options[0]).focus();
  }

  if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
    e.preventDefault();
    (options[index - 1] || options[options.length - 1]).focus();
  }

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    current.click();
  }
});

// Make labels focusable
document.querySelectorAll('.product-single__meta .swatch-element label')
  .forEach(label => label.setAttribute('tabindex', '0'));

// Selected size
$(document).on('click change', '.swatch-element input[type="radio"]', function() {
  var $radio = $(this);
  if ($radio.prop('checked')) {
    setTimeout(function() {
      var optionName = $radio.closest('.swatch').find('.label').text().split(':')[0].trim();
      var optionValue = $radio.val();
      
      $radio.closest('.swatch').find('.js-swatch-label-val').text(optionValue);
      
      var $announcer = $('#swatch-announcer');
      if (!$announcer.length) {
        $announcer = $('<div id="swatch-announcer" aria-live="polite" class="visually-hidden"></div>');
        $('body').append($announcer);
      }
      $announcer.text(optionName + ' ' + optionValue + ' selected');
    }, 50);
  }
});

$(document).on('keydown', '.swatch-element label', function(e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    e.preventDefault();
    var $radio = $(this).closest('.swatch-element').find('input[type="radio"]');
    if ($radio.length && !$radio.prop('disabled')) {
      $radio[0].click();
    }
  }
});


/* ============================================
 * Cart Page: Govx widget
 ============================================ */
setTimeout(() => {
  document.querySelectorAll('.template-cart .ge-hide.ge-hide-us p').forEach(p => {
    p.setAttribute('tabindex', '0');
  });

  document.querySelectorAll('.template-cart .ge-hide.ge-hide-us a').forEach(a => {
    if (a.getAttribute('target') === 'popup') {
      a.setAttribute('aria-label', 'govx button');
    } else {
      const text = (a.textContent || '')
        .replace(/<[^>]*>/g, '')
        .trim();

      if (text) {
        a.setAttribute('aria-label', text);
      }
    }
  });
}, 3000);


/* ============================================
 * Policies
 ============================================ */
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll(`
      .template-page .main-page .rte h1,
      .template-page .main-page .rte h2,
      .template-page .main-page .rte h3,
      .template-page .main-page .rte h4,
      .template-page .main-page .rte h5,
      .template-page .main-page .rte h6,
      .template-page .main-page .rte p,
      .template-page .main-page .rte li,
      .template-page .main-page .rte ul,
      .template-page .main-page .rte ol,
      .template-page .main-page .rte td,
      .template-page .main-page .rte strong:not(td strong),
      .template-page .main-page .rte em
    `)
    .forEach(el => {
      el.setAttribute('tabindex', '0');
    });

  document
    .querySelectorAll('.template-page .main-page .rte a')
    .forEach(a => {
      const text = (a.textContent || '')
        .replace(/<[^>]*>/g, '')
        .trim();

      if (text) {
        a.setAttribute('aria-label', text);
      }
    });
});


/* ============================================
 * Contact Page
 ============================================ */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.rte.contact_page_content');
  if (!wrapper) return;

  wrapper.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, ul, ol')
    .forEach(el => {
      el.setAttribute('tabindex', '0');
    });

  wrapper.querySelectorAll('a').forEach(a => {
    let label = a.textContent || a.getAttribute('href') || '';

    label = label
      .replace(/<[^>]*>/g, '')
      .trim();

    if (label) {
      a.setAttribute('aria-label', label);
    }
  });
});


/* ============================================
 * Store Locator Page
 ============================================ */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.rich-text__wrapper--center .rich-text__text.rte');
  if (!wrapper) return;

  wrapper.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, ul, ol')
    .forEach(el => {
      el.setAttribute('tabindex', '0');
    });

  wrapper.querySelectorAll('a').forEach(a => {
    let label = (a.textContent || '')
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!label) {
      label = a.getAttribute('href') || '';
    }

    a.setAttribute('aria-label', label);
  });
});


/* ============================================
 * Exclusive Access Page
 ============================================ */
setTimeout(() => {
  const wrapper = document.querySelector('.klaviyo-form-T6DNWP');
  if (!wrapper) return;

  wrapper.querySelectorAll('img, h1, p, span').forEach(el => {
    const h1HasMedia =
      el.tagName === 'H1' &&
      (el.querySelector('img') || el.querySelector('span'));

    if (h1HasMedia) return;

    if (el.tagName === 'IMG') {
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Lems shop');
      return;
    }

    if (el.tagName === 'SPAN') {
      el.setAttribute('tabindex', '0');
      return;
    }

    el.setAttribute('tabindex', '0');
  });
}, 5000);


/* ============================================
 * Govx Page
 ============================================ */
setTimeout(() => {
  const wrapper = document.querySelector('.govx-id-page');
  if (!wrapper) return;

  wrapper.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, .footer-item')
    .forEach(el => {
      el.setAttribute('tabindex', '0');
    });

  wrapper.querySelectorAll('button, a')
    .forEach(el => {
      el.setAttribute('tabindex', '0');
    });
}, 5000);


/* ============================================
 * Pro Program Page
 ============================================ */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.page--proprogram');
  if (!wrapper) return;

  wrapper.querySelectorAll('p').forEach(p => {
    p.setAttribute('tabindex', '0');
  });

  wrapper.querySelectorAll('a').forEach(a => {
    const text = (a.textContent || '')
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (text) {
      a.setAttribute('aria-label', text);
    }
  });

  wrapper.querySelectorAll('.field--heading h5').forEach(h5 => {
    h5.setAttribute('tabindex', '0');
  });
});